export const MIN_ASSETS_NUMBER_FOR_3D_MODEL = 6
